module.exports = __webpack_public_path__ + "static/sportenPremium-873d088896dc1f7633b3d14c38db5fad.svg";